var LG = 1024;
var details = document.querySelectorAll(".l-search-group__item:not(#search-group-0)");
if (details.length) {
    var syncOpen = function () {
        var isLg = window.innerWidth >= LG;
        details.forEach(function (el) {
            if (isLg) {
                el.setAttribute("open", "");
            }
            else {
                el.removeAttribute("open");
            }
        });
    };
    syncOpen();
    var mq = window.matchMedia("(min-width: ".concat(LG, "px)"));
    mq.addEventListener("change", syncOpen);
}
